angular.module('bmsApp.resource')
	.controller('ResourceReadCtrl', [
		'$stateParams',
		'$window',
		'$http',
		'notify',
		'ResourceSvc',
		function ($stateParams,
				  $window,
				  $http,
				  notify,
				  ResourceSvc) {

			var self = this;

			function init() {
				self.loading = true;
				ResourceSvc.resource.read({
					id: $stateParams.resourceId
				})
					.then(function (response) {
						self.resource = response.data.resource;
					})
					.finally(function () {
						self.loading = false;
					});
			}

			function getType() {
				return self.resource && ResourceSvc.resource.getType(self.resource);
			}

			function getContents() {
				$http.get(self.resource.view_url)
					.then(function (response) {
						self.resource.file.contents = response.data;
					});
			}

			function download() {
				ResourceSvc.resource.download({
					id: self.resource.id,
				});
			}

			function confirmReceipt() {
				self.confirmReceiptPromise = ResourceSvc.receipt.confirm({
					id: self.resource.bms_receipts[0].id
				})
					.then(function (response) {
						self.resource.bms_receipts[0] = response.data.receipt;
						notify({
							message: 'Receipt Confirmed'
						});
					});
			}

			function createSignUrl() {
				self.createSignUrlPromise = ResourceSvc.resource.generateSigningUrl(self.resource)
					.then(function (response) {
						$window.location.href = response.data.signingUrl;
					});
			}

			angular.extend(self, {
				confirmReceiptPromise: undefined,
				createSignUrlPromise: undefined,
				methods: {
					init: init,
					getType: getType,
					getContents: getContents,
					download: download,
					confirmReceipt: confirmReceipt,
					createSignUrl: createSignUrl,
				}
			});

		}
	]);
